import { render, staticRenderFns } from "./InfocardBaseForm.vue?vue&type=template&id=38c27eb8&scoped=true&"
import script from "./InfocardBaseForm.vue?vue&type=script&lang=js&"
export * from "./InfocardBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./InfocardBaseForm.vue?vue&type=style&index=0&id=38c27eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c27eb8",
  null
  
)

export default component.exports